/**
 *  Module for sending analytics to omniture and google analytics
 */

const Analytics = function (app) {

  /**
   *  Private Properties/Methods
   */

  const localAnalytics = require('./_localAnalytics')();

  const showAnalytics = app.mergedParams.showAnalytics;
  const tools = require('./tools')(app);
  const digitalDataTool = require('./digital_data_tool')(app);

  if (showAnalytics) {
    localAnalytics.showLogging();
  }

  // Only show missing analytics object errors once
  const eventCategory = 'Configure';

  // Sends analytics data to google, omniture for various events
  function track(event, data) {
    app.analytics.incrementalNumber++;
    let properties = {},
      eventName = 'Fluid Configure';
    const recipeId = tools.getRecipeId(data),
      // quantity = configure.run('getQuantity'),
      styleId = tools.getStyleId();
    // to avoid errors we create digitalData if it's not in scope.
    if (!window.digitalData) {
      window.digitalData = {};
    }
    // Get event specific parameters for ga and omniture
    switch (event) {
      case 'configure-loaded':
        properties.action = 'Configure Loaded';
        properties = tools.getProperties(properties, recipeId, true);

        // Set the session event
        tools.setSession();

        tools.getSelectionsString();
        /* ----------  Customer Analytics  ---------- */
        digitalData = digitalDataTool.configureLoaded();
        break;

      case 'recipe-changed':
        properties.action = 'Recipe Changed';
        const recipe_change = tools.getChanges(data);
        if (recipe_change) {
          properties.customization = recipe_change;
        }
        properties = tools.getProperties(properties);
        /* ----------  Customer analytics  ---------- */
        digitalData = digitalDataTool.recipeChanged(recipeId);
        break;

      case 'attribute-opened':
        properties.action = 'Attribute Opened';
        properties = tools.getProperties(properties);
        properties.attribute = data.attr.id;
        /* ----------  Customer analytics  ---------- */
        digitalData = digitalDataTool.attributeOpened(recipeId, data);
        break;

      case 'add-to-cart':
        properties.action = 'Add to Cart';
        properties = tools.getProperties(properties, recipeId);
        properties.selections = tools.getSelectionsString();
        properties.id = styleId;

        data.recipe.styleId = styleId;
        tools.recipeCreated(data.recipe);

        eventName = 'Added Product';
        /* ----------  Customer analytics  ---------- */
        digitalData = digitalDataTool.addToCart(recipeId, data);

        break;

      case 'edit-cart':
        properties.action = 'Update Cart';
        properties = tools.getProperties(properties, recipeId);
        properties.selections = tools.getSelectionsString();

        eventName = 'Added Product';
        /* ----------  customer analytics  ---------- */
        digitalData = digitalDataTool.editCart(recipeId, data);

        break;

      case 'add-to-wishlist':
        properties.action = 'Add to Wishlist';
        properties = tools.getProperties(properties, recipeId);
        properties.selections = tools.getSelectionsString();
        break;

      case 'add-to-catalog':
        properties.action = 'Add to Catalog';
        properties = tools.getProperties(properties, recipeId);
        properties.selections = tools.getSelectionsString();
        /* ----------  customer analytics  ---------- */
        digitalData = digitalDataTool.addToCatalog(recipeId, data);

        break;

      case 'share-email':
        properties.action = 'Share Email';
        properties = tools.getProperties(properties, recipeId, true);
        properties.selections = tools.getSelectionsString();

        /* ----------  customer analytics  ---------- */
        digitalData = digitalDataTool.shareEmail(recipeId, data);

        break;

      case 'share-facebook':
        properties.action = 'Share Facebook';
        properties = tools.getProperties(properties, recipeId, true);
        properties.selections = tools.getSelectionsString();
        /* ----------  customer analytics  ---------- */
        digitalData = digitalDataTool.shareFacebook(recipeId, data);

        break;

      case 'share-twitter':
        properties.action = 'Share Twitter';
        properties = tools.getProperties(properties, recipeId, true);
        properties.selections = tools.getSelectionsString();
        /* ----------  customer analytics  ---------- */
        digitalData = digitalDataTool.shareTwitter(recipeId);

        break;

      case 'share-pinterest':
        properties.action = 'Share Pinterest';
        properties = tools.getProperties(properties, recipeId, true);
        properties.selections = tools.getSelectionsString();
        /* ----------  customer analytics  ---------- */
        digitalData = digitalDataTool.sharePinterest(recipeId);
        break;

      case 'print':
        properties.action = 'Print';
        properties = tools.getProperties(properties, recipeId);
        properties.selections = tools.getSelectionsString();
        /* ----------  customer analytics  ---------- */
        digitalData = digitalDataTool.print(recipeId, data);

        break;

      case 'start-over':
        properties.action = 'Start Over';
        properties = tools.getProperties(properties);
        properties.selections = tools.getSelectionsString();
        /* ----------  customer analytics  ---------- */
        digitalData = digitalDataTool.startOver(recipeId);

        break;

      case 'randomize':
        properties.action = 'Surprise Me';
        properties = tools.getProperties(properties, recipeId);
        break;

      case 'snapshot-add':
        properties.action = 'Snapshot Add';
        properties = tools.getProperties(properties);
        break;

      case 'snapshot-delete':
        properties.action = 'Snapshot Delete';
        properties = tools.getProperties(properties, recipeId);
        break;

      case 'snapshot-load':
        properties.action = 'Snapshot Load';
        properties = tools.getProperties(properties, recipeId);
        break;

      case 'catalog-item-clicked':
        properties.action = 'Catalog Item Clicked';
        properties = tools.getProperties(properties, recipeId);
        /* ----------  customer analytics  ---------- */
        digitalData = digitalDataTool.catalogItemClicked(recipeId);

        break;

      case 'color-has-no-size':
        properties.action = 'Color AV Removed';
        properties = tools.getProperties(properties);
        properties.attribute = data.ca.id;
        properties.value = data.av.id;
        properties.valueVendorId = data.av.vendorId;
        break;

      case 'product-has-no-colors':
        properties.action = 'Product Has No Colors';
        properties = tools.getProperties(properties);
        break;

      case 'replace-default-recipe':
        properties.action = 'Replace Default Recipe';
        properties = tools.getProperties(properties);
        properties.recipeId = data.recipeId;
        properties.productId = data.productId;
        break;

      default:
        if (showAnalytics) {
          console.log('track analytics: ' + event + ' not supported');
        }
        return;
    }

    if (showAnalytics) {
      localAnalytics.track(eventName, properties);
      const stringifiedDigitalData = JSON.stringify(digitalData, null, 2);
      console.log('%c digitalData: ' + stringifiedDigitalData, 'background: #008080; color: #bada55');
    }

    if (typeof ga !== 'undefined') {
      if (showAnalytics) {
        console.log('ga', 'event', eventCategory, properties.action, tools.parseProperties(properties));
      }

      ga('Fluid.send', 'event', eventCategory, properties.action, tools.parseProperties(properties));
    } else {
      if (showAnalytics) {
        console.error('Google Analytics object "ga" is not found');
      }
    }
    window._analyticsShowError = false;
  }
  const init = () => app.analytics.incrementalNumber = 0;

  /**
   *  Expose Public Properties/Methods
   */
  return {
    getSelections: tools.getSelections,
    getSelectionsString: tools.getSelectionsString,
    init,
    track
  };
};

module.exports = Analytics;
